import { GetApiConvertedFilesApiResponse } from "src/app/services/api.generated";
import { ColumnModes, ColumnType } from "src/types/genericTable.types";
import { ActionButtonModes } from "src/types/actionButton.types";
import { ActionModes } from "src/types/actionItems.types";
import theme from "src/configs/theme/theme";

const colors = new Map<string, string>([
  ["در حال پردازش", theme.palette.warning.light],
  ["تکمیل شده", theme.palette.success.main],
]);

export const ConvertedFilesData: ColumnType<GetApiConvertedFilesApiResponse>[] =
  [
    {
      type: ColumnModes.DATA,
      id: "converted_file_name",
      label: "نام فایل",
      chip: false,
      color: "",
    },
    {
      type: ColumnModes.DATA,
      id: "bitrate",
      label: "bitrate",
      chip: false,
      color: "",
    },
    {
      type: ColumnModes.DATA,
      id: "quality",
      label: "کیفیت",
      chip: false,
      color: "",
    },
    {
      type: ColumnModes.DATA,
      id: "folderName",
      label: "نام پوشه",
      chip: false,
      color: "",
    },
    {
      type: ColumnModes.DATA,
      id: "file_status",
      label: "وضعیت فایل",
      chip: true,
      color: colors,
    },
  ];
